import { FormType } from '../../../form-types';

const antiAgingBelugaFollowup: FormType = {
  name: 'Anti-Aging Follow Up Visit',

  questions: [
    'antiAgingBelugaFollowup_sexAssignedAtBirth',
    'generic_heightWeight2025',
    {
      key: 'antiAgingBelugaFollowup_healthChanges',
      next: {
        condition: {
          'antiAgingBelugaFollowup_healthChanges.antiAgingBelugaFollowup_healthChanges_yes':
            true
        },
        key: 'antiAgingBelugaFollowup_healthChangesDetails',
        els: 'antiAgingBelugaFollowup_medicationExperience'
      }
    },
    'antiAgingBelugaFollowup_healthChangesDetails',
    {
      key: 'antiAgingBelugaFollowup_medicationExperience',
      next: {
        condition: {
          'antiAgingBelugaFollowup_medicationExperience.antiAgingBelugaFollowup_medicationExperience_notWell':
            true
        },
        key: 'antiAgingBelugaFollowup_medicationExperienceDetails',
        els: 'antiAgingBelugaFollowup_sideEffects'
      }
    },
    'antiAgingBelugaFollowup_medicationExperienceDetails',
    {
      key: 'antiAgingBelugaFollowup_sideEffects',
      next: {
        condition: {
          'antiAgingBelugaFollowup_sideEffects.antiAgingBelugaFollowup_sideEffects_yes':
            true
        },
        key: 'antiAgingBelugaFollowup_sideEffectsDetails',
        els: 'antiAgingBelugaFollowup_additionalInfo'
      }
    },
    'antiAgingBelugaFollowup_sideEffectsDetails',
    'antiAgingBelugaFollowup_additionalInfo',
    {
      key: 'antiAgingBelugaFollowup_consent',
      next: {
        condition: {
          'antiAgingBelugaFollowup_consent.antiAgingBelugaFollowup_consent_disagree':
            true
        },
        key: 'antiAgingBelugaFollowup_didNotConsent',
        els: 'antiAgingBelugaFollowup_complete'
      }
    },
    'antiAgingBelugaFollowup_ineligible',
    'antiAgingBelugaFollowup_didNotConsent',
    'antiAgingBelugaFollowup_complete'
  ]
};
export default antiAgingBelugaFollowup;
